/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { StatutoryDepositRequest } from '../models';
import { StatutoryDepositSummaryIEnumerableResponse } from '../models';
import { StatutoryDepositTransactionIEnumerableResponse } from '../models';
/**
 * StatutoryDepositApi - axios parameter creator
 * @export
 */
export const StatutoryDepositApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns StatutoryDepositSummaries
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet: async (practiceId: number, investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet.');
            }
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/StatutoryDeposit/GetSummaryBankInformation/{practiceId}/{investigationId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)))
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns StatutoryDepositTransactions
         * @param {StatutoryDepositRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2StatutoryDepositGetTransactionsPost: async (body?: StatutoryDepositRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/StatutoryDeposit/GetTransactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatutoryDepositApi - functional programming interface
 * @export
 */
export const StatutoryDepositApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns StatutoryDepositSummaries
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatutoryDepositSummaryIEnumerableResponse>> {
            const localVarAxiosArgs = await StatutoryDepositApiAxiosParamCreator(configuration).apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet(practiceId, investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns StatutoryDepositTransactions
         * @param {StatutoryDepositRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2StatutoryDepositGetTransactionsPost(body?: StatutoryDepositRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatutoryDepositTransactionIEnumerableResponse>> {
            const localVarAxiosArgs = await StatutoryDepositApiAxiosParamCreator(configuration).apiV2StatutoryDepositGetTransactionsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StatutoryDepositApi - factory interface
 * @export
 */
export const StatutoryDepositApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns StatutoryDepositSummaries
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any): AxiosPromise<StatutoryDepositSummaryIEnumerableResponse> {
            return StatutoryDepositApiFp(configuration).apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet(practiceId, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns StatutoryDepositTransactions
         * @param {StatutoryDepositRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2StatutoryDepositGetTransactionsPost(body?: StatutoryDepositRequest, options?: any): AxiosPromise<StatutoryDepositTransactionIEnumerableResponse> {
            return StatutoryDepositApiFp(configuration).apiV2StatutoryDepositGetTransactionsPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatutoryDepositApi - object-oriented interface
 * @export
 * @class StatutoryDepositApi
 * @extends {BaseAPI}
 */
export class StatutoryDepositApi extends BaseAPI {
    /**
     * 
     * @summary Returns StatutoryDepositSummaries
     * @param {number} practiceId 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutoryDepositApi
     */
    public apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any) {
        return StatutoryDepositApiFp(this.configuration).apiV2StatutoryDepositGetSummaryBankInformationPracticeIdInvestigationIdGet(practiceId, investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns StatutoryDepositTransactions
     * @param {StatutoryDepositRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatutoryDepositApi
     */
    public apiV2StatutoryDepositGetTransactionsPost(body?: StatutoryDepositRequest, options?: any) {
        return StatutoryDepositApiFp(this.configuration).apiV2StatutoryDepositGetTransactionsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
